var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.root.children),function(child){return _c('li',{key:child.id,staticClass:"tree-list"},[_c('catalog',{attrs:{"catalog":child}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }